import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ApiDocsLanding from "./ApiDocsLanding";

const ApiDocs = () => {
  return (
    <Switch>
      <Route exact path="/" component={ApiDocsLanding} />
      <Redirect to="/" />
    </Switch>
  );
};

export default ApiDocs;
